import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      fontSize: get('fontSizes.14'),
      height: get('space.20'),
      lineHeight: get('lineHeights.20'),
      padding: props => "".concat(get('space.5')(props), " ").concat(get('space.11')(props))
    },
    medium: {
      fontSize: get('fontSizes.16'),
      height: get('space.24'),
      lineHeight: get('lineHeights.24'),
      padding: props => "".concat(get('space.7')(props), " ").concat(get('space.15')(props))
    },
    large: {
      fontSize: get('fontSizes.16'),
      height: get('space.24'),
      lineHeight: get('lineHeights.24'),
      padding: props => "".concat(get('space.11')(props), " ").concat(get('space.23')(props))
    }
  }
});
const variants = {
  fit
};
const ParentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  flex-direction: row;\n"])));
const Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  overflow: auto;\n"])));
const List = styled.ul(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0;\n  margin: 0;\n"])));
const Item = styled.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  list-style: none;\n  @media screen and (max-width: 700px) {\n    &:not(:first-child):not(.active):not(:last-child),\n    .mc-pagination-host--elipsis {\n      display: none;\n    }\n  }\n"])));
const paginationDefault = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), get('colors.functional.grey.900'), get('colors.functional.grey.200'), get('colors.functional.grey.700'));
const paginationActive = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), get('colors.functional.grey.50'), get('colors.primary.blue.900'), get('colors.primary.blue.800'), get('colors.functional.grey.50'));
const paginationDisabled = props => {
  const color = "".concat(get('colors.functional.grey.800')(props), "80");
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    cursor: not-allowed;\n    color: ", ";\n  "])), color);
};
const Link = styled.a.attrs(_ref => {
  let {
    disabled,
    children,
    variant = 'default',
    onClick
  } = _ref;
  return {
    disabled,
    variant,
    children,
    onClick
  };
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: ", ";\n  &:last {\n    margin-right: 0;\n  }\n  ", "\n"])), props => props.disabled && {
  cursor: 'not-allowed'
}, variants.fit, get('borderRadius.m'), props => props.variant === 'active' ? paginationActive : props.variant === 'disabled' ? paginationDisabled(props) : paginationDefault);
const Select = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 9.5rem;\n"])));
const Components = {
  ParentWrapper,
  Wrapper,
  List,
  Item,
  Link,
  Select
};
export { Components };